export default class HttpResponseError extends Error {
  constructor(
    message: string,
    public response: Response,
  ) {
    super(`HTTP error ${response.status}: ${message}`);
  }
}
